document.addEventListener("DOMContentLoaded", function() {
  const menuList = document.querySelector(".header-sidebar__linklist"); // `ul` 要素を取得
  const menuLinks = menuList ? menuList.querySelectorAll("li a") : []; // `li` 内の `a` タグを取得
  const drawer = document.querySelector(".drawer"); // メニュー本体

  if (menuLinks.length > 0 && drawer) {
    menuLinks.forEach(function(link) {
      link.addEventListener("click", function() {
        // メニューを閉じる（.drawer から ::part(base) を削除）
        drawer.removeAttribute("open");
      });
    });
  } 
});
// メルマガ登録後ありがとうページ
document.addEventListener("DOMContentLoaded", function () {
    const forms = document.querySelectorAll("form.increased-spacing");

    forms.forEach(form => {
        // ✅ `return_to` がすでにあるか確認し、なければ追加
        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
            returnTo = document.createElement("input");
            returnTo.type = "hidden";
            returnTo.name = "return_to";
            returnTo.value = "/pages/thanks-page";
            form.appendChild(returnTo);
        }

        form.addEventListener("submit", function (event) {
            // ✅ 通常のフォーム送信を維持
            setTimeout(function () {
                window.location.href = "/pages/thanks"; // ✅ 送信後にリダイレクト
            }, 500); // 0.5秒後に遷移
        });
    });
});